import { ReactNode } from 'react';
import { Card } from '_common/lib/components';

import styles from './Body.module.scss';

type BodyProps = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const Body = ({ children, style }: BodyProps) => {
  return (
    <Card.Body style={style}>
      <div className={styles.root}>{children}</div>
    </Card.Body>
  );
};

const Header = ({ children, style }: BodyProps) => {
  return (
    <div className={styles.header} style={style}>
      {children}
    </div>
  );
};

export default Object.assign(Body, {
  Header,
});
